import React from 'react';
import PropTypes from 'prop-types';


const Arrow = ({ extraClassName }) => (
  <span className={extraClassName} >
    <svg width="24" height="24">
      {/* eslint-disable-next-line max-len*/}
      <path fill="#BE5B04" fillRule="evenodd" d="M3.941 12.996l6.243 6.244a1.026 1.026 0 0 1-1.452 1.452L.59 12.574 0 12.006l.01-.01-.01-.01.59-.568L8.732 3.3a1.028 1.028 0 0 1 1.452 1.452l-6.243 6.244h19.128a.997.997 0 0 1 .997 1c-.001.553-.45 1-1.003 1H3.94z" />
    </svg>
  </span>
);

Arrow.propTypes = {
  extraClassName: PropTypes.string,
};
export default Arrow;
